import styled, { css } from 'styled-components'
import { theme } from '../../styles'

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
  margin-bottom: 16px;
`

export const Label = styled.label`
  font-size: 12.5px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: ${theme.cores.inkSoft};
`

const campoBase = css`
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  border: 1.5px solid ${( { $err } ) => ( $err ? theme.cores.statusStop : theme.cores.lineStrong )};
  background: ${( { $err } ) => ( $err ? theme.cores.white : theme.cores.paperAlt )};
  color: ${theme.cores.inkDeep};
  font-size: 15px;
  font-family: inherit;
  outline: none;
  transition: border-color 0.14s ease, box-shadow 0.14s ease, background 0.14s ease;

  &::placeholder {
    color: ${theme.cores.inkFaint};
  }

  &:focus {
    border-color: ${theme.cores.navy};
    background: ${theme.cores.white};
    box-shadow: 0 0 0 4px rgba(38, 42, 95, 0.1);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  ${( { $err } ) => ( $err
    ? `box-shadow: 0 0 0 4px rgba(178, 58, 51, 0.12);`
    : '' )}

  ${theme.mobile} {
    font-size: 16px;
  }
`

export const Input = styled.input`
  ${campoBase}
`

export const Select = styled.select`
  ${campoBase}
  appearance: none;
  cursor: pointer;
  padding-right: 38px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%235A5C75' stroke-width='2.2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
`

export const FieldError = styled.div`
  color: ${theme.cores.statusStop};
  font-size: 12px;
  font-weight: 600;
`

export const FieldHint = styled.div`
  margin-top: 6px;
  font-size: 12px;
  color: ${theme.cores.inkSoft};
`

export const Row2 = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px;

  ${theme.mobile} {
    grid-template-columns: 1fr;
  }
`
